import { ALL_NON_ALPHANUMERIC_OR_HYPHENS, ALL_SPACES_REGEX } from 'app/lib/constants'

export const slufigy = (str: string): string =>
  str.toLowerCase().replace(ALL_SPACES_REGEX, '-').replace(ALL_NON_ALPHANUMERIC_OR_HYPHENS, '')
